// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__wFpQT","selected":"Chip_selected__U2BX_"};